export default ['get-involved', 'learn', 'get-support', 'about']